import React from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/Button';

interface FilterButtonProps {
  onClick?: () => void;
  filterCount?: number;
  label?: string;
  showBadge?: boolean;
  disabled?: boolean;
  className?: string;
  variant?: 'default' | 'compact';
}

const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  filterCount = 0,
  label = "Filtros",
  showBadge = true,
  disabled = false,
  className,
  variant = 'default'
}) => {
  const showCount = showBadge && filterCount > 0;

  if (variant === 'compact') {
    return (
      <Button
        variant="outline"
        onClick={onClick}
        disabled={disabled}
        className={cn(
          "flex h-10 px-5 items-center gap-2 rounded-full border border-gray-text",
          className
        )}
      >
        <div className="flex items-center gap-2">
          <div className="relative">
            <SlidersHorizontal className="w-5 h-5 text-gray-text" />
            {showCount && (
              <div className="absolute -top-1 -right-1 flex w-4 h-4 items-center justify-center rounded-full bg-gray-text text-[10px] font-normal text-white">
                {filterCount}
              </div>
            )}
          </div>
          <span className="text-sm font-normal text-gray-text">
            {label}
          </span>
        </div>
      </Button>
    );
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "flex h-12 px-6 lg:px-8 items-center gap-3 w-full sm:w-auto rounded-full border border-gray-text transition-colors",
        disabled
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-neutral-gray-bg active:bg-neutral-gray-bg/80",
        className
      )}
    >
      <SlidersHorizontal className="w-6 h-6 text-gray-text" />
      <div className="flex items-center gap-2">
        <span className="text-base font-normal text-gray-text leading-normal whitespace-nowrap">
          {label}
        </span>
        {showBadge && filterCount > 0 && (
          <span className="flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-neutral-black text-white text-xs font-medium">
            {filterCount}
          </span>
        )}
      </div>
    </button>
  );
};

export { FilterButton, type FilterButtonProps };
export default FilterButton;